import moment from "moment";

export function getKhmerNumber(number) {
  let numArr = number?.toString()?.split("");

  let numberKh = ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"];
  let newArr = [];

  for (let i = 0; i < numArr?.length; i++) {
    if (isNaN(parseFloat(numArr[i]))) {
      newArr.push(numArr[i]);
      continue;
    }
    newArr.push(numberKh[numArr[i]]);
  }
  return newArr?.join("");
}

export function toEnglishNumber(input) {
  const khmerToEnglishMap = {
    "០": "0",
    "១": "1",
    "២": "2",
    "៣": "3",
    "៤": "4",
    "៥": "5",
    "៦": "6",
    "៧": "7",
    "៨": "8",
    "៩": "9",
  };

  return input
    ?.toString()
    .split("")
    .map((char) => {
      if (khmerToEnglishMap[char]) {
        return khmerToEnglishMap[char];
      } else if (/[0-9()]/.test(char)) {
        return char;
      }
      // Skip other characters
      return "";
    })
    .join("");
}

export const getDateRangeByStartEnd = (start, end) => {
  var dateStart = moment(start);
  var dateEnd = moment(end);
  var timeValues = [];

  while (dateEnd > dateStart || dateStart.format("M") === dateEnd.format("M")) {
    timeValues.push(dateStart.format("YYYY-MM-DD"));
    dateStart.add(1, "month");
  }
  return timeValues;
};

export function getKhmerMonth(date) {
  if (date === "January") return "មករា";
  if (date === "February") return "កុម្ភៈ";
  if (date === "March") return "មិនា";
  if (date === "April") return "មេសា";
  if (date === "May") return "ឧសភា";
  if (date === "June") return "មិថុនា";
  if (date === "July") return "កក្កដា";
  if (date === "August") return "សីហា";
  if (date === "September") return "កញ្ញា";
  if (date === "October") return "តុលា";
  if (date === "November") return "វិច្ឆិកា";
  if (date === "December") return "ធ្នូ";

  const month = parseFloat(date);

  if (month === 1) return "មករា";
  if (month === 2) return "កុម្ភៈ";
  if (month === 3) return "មិនា";
  if (month === 4) return "មេសា";
  if (month === 5) return "ឧសភា";
  if (month === 6) return "មិថុនា";
  if (month === 7) return "កក្កដា";
  if (month === 8) return "សីហា";
  if (month === 9) return "កញ្ញា";
  if (month === 10) return "តុលា";
  if (month === 11) return "វិច្ឆិកា";
  if (month === 12) return "ធ្នូ";

  return month;
}

export function getKhmerDay(day) {
  const khmerDays = {
    monday: "ចន្ទ",
    tuesday: "អង្គារ",
    wednesday: "ពុធ",
    thursday: "ព្រហស្បតិ៍",
    friday: "សុក្រ",
    saturday: "សៅរ៍",
    sunday: "អាទិត្យ",
  };
  if (typeof day !== "string") return null;
  return khmerDays[day.toLowerCase()] || null;
}

// export const toLatinUppercase = (text) => {
//   return text.replace(/[a-z]/gi, (char) => char.toUpperCase());
// };

export const toLatinUppercase = (text) => {
  return text
    .replace(/[^a-zA-Z ]/g, "") // Allow Latin letters and spaces only
    .toUpperCase(); // Convert to uppercase
};

export function calculateNumberOfDay(borrowing_date, first_payment_date) {
  if (
    !(borrowing_date instanceof Date) ||
    !(first_payment_date instanceof Date)
  ) {
    throw new Error("Both arguments must be Date objects.");
  }

  // Clear the time portion to avoid partial day issues
  const start = new Date(
    borrowing_date.getFullYear(),
    borrowing_date.getMonth(),
    borrowing_date.getDate()
  );
  const end = new Date(
    first_payment_date.getFullYear(),
    first_payment_date.getMonth(),
    first_payment_date.getDate()
  );

  const msInOneDay = 1000 * 60 * 60 * 24;
  const differenceInTime = end - start;

  return differenceInTime / msInOneDay;
}
 
export const formatPhoneNumber = (value) => {
  if (!value) return "";

  const cleaned = value.replace(/\D/g, ""); // remove non-digits
  const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

  if (!match) return value;

  return [match[1], match[2], match[3]].filter(Boolean).join(" ");
};

export function currencyFormat(num) {
  return num?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

export function currencyFormatRiel(num) {
  return num?.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

export function increaseNumber(num) {
  let numFormat = num.split(".");
  // console.log("num::", numFormat);
  return num.toFixed(2);
}

// Khmer month name
const khmerMonths = [
  "មករា",
  "កុម្ភៈ",
  "មីនា",
  "មេសា",
  "ឧសភា",
  "មិថុនា",
  "កក្កដា",
  "សីហា",
  "កញ្ញា",
  "តុលា",
  "វិច្ឆិកា",
  "ធ្នូ",
];

// get Khmer month name
export const getKhmerMonthName = (date) => {
  const monthIndex = date ? new Date(date).getMonth() : 0;
  return khmerMonths[monthIndex];
};

export const getKhmerYear = (date) => {
  if (!date) return "";
  const year = new Date(date).getFullYear().toString();
  const khmerDigits = ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"];
  return year
    .split("")
    .map((digit) => khmerDigits[digit])
    .join("");
};

export const padStartINV = (num) => {
  const number = num || 0;
  const formatted = "INV" + number?.toString()?.padStart(6, "0");
  return formatted;
};

export function getKhmerDate(date) {
  return (
    getKhmerNumber(new Date(date).getDate()) +
    " " +
    getKhmerMonthName(date) +
    " " +
    getKhmerYear(date)
  );
}

export function generateInvoiceNumber(invNumber) {
  const prefix = "INV";
  const yearCode = new Date().getFullYear().toString().slice(-2); // "25" for 2025
  const number = String(invNumber).padStart(6, "0"); // "00001"
  return `${prefix}${yearCode}${number}`;
}
